import { useEffect, useState } from "react";

export const CAT_MODE_KEY = "dl_cat_mode";
export const CAT_MODE_EVENT = "dl-cat-mode-change";

const driveImage = (id) => `https://drive.google.com/thumbnail?id=${id}&sz=w500`;

const normalizeHeroName = (name) => String(name || "").toLowerCase().replace(/&/g, "and").replace(/[^a-z0-9]+/g, "");

const CAT_HERO_IMAGES = {
  abrams: driveImage("1wweapy-nnP3hyljGxBjWfRXDYyPWtW7a"), apollo: driveImage("1-qQD6TjPVjNsgTFN8ihWC22ohRsEN2Eu"), bebop: driveImage("1M2DtXO77BGJbiNqEE_lBcZKu1zdmUdOv"), billy: driveImage("1eMra4ihwipIyriABs51x2OT-PSX_BuVv"), calico: driveImage("1831Qkrv-J7W3DSeDVzolwNc5TdT5557_"), celeste: driveImage("18orn99fjvFnozbHbBvHnPOhDXAiMC4od"), doorman: driveImage("14LlDcuO7E9kf6rmZPpvw-g4GGau2wIbR"), thedoorman: driveImage("14LlDcuO7E9kf6rmZPpvw-g4GGau2wIbR"), drifter: driveImage("17Ot4v85dmOE_mVZycJCUdpliQnuNWmpW"), dynamo: driveImage("1Pk0XbYGLF6fFII3RYjdWPT0RzzBY6bU1"), greytalon: driveImage("1M8-BmNc1sHzMQubbQzuFCSw9NJ-MCEhR"), graves: driveImage("1BzOT3mxqlHIShZv3-UTmaOgDpwUfAk7m"), haze: driveImage("1cPYhYVvBT-x5-bOAm40WObx3ZUIBM1l8"), holiday: driveImage("1iI9TXqpjyrCaO8YdD7MPhcUUNIbapbpS"), holliday: driveImage("1iI9TXqpjyrCaO8YdD7MPhcUUNIbapbpS"), infernus: driveImage("1rXtcWQpzOXXJiUlCO3emIw9NDyhvyhFb"), ivy: driveImage("1yPCi3ntc5DgRLNGfhhkgXxG4Lvjs3MkW"), kelvin: driveImage("1wBfJbQMUwtambbniRh7GcbHStbX1DOSj"), ladygiest: driveImage("1-t18YVYa8u6WipjV15Nyu0a44VXLSyOQ"), ladygeist: driveImage("1-t18YVYa8u6WipjV15Nyu0a44VXLSyOQ"), lash: driveImage("1QelVHe13vz4HMKFWouRUwknaedXoGazF"), mcginnis: driveImage("1tJv9D-bQdXYPkjlwuwOIF-XRAC1echts"), mina: driveImage("1_Pl06tEKRXl2XNcfon-TeDJAbdDKfpNC"), mirage: driveImage("1zbHPsZ21nouc-gSf5TGC2cLimJitKcXV"), moeandkrill: driveImage("1VlYOxGzLtTXkYv7lLYjTHRWzVbcllrw_"), moandkrill: driveImage("1VlYOxGzLtTXkYv7lLYjTHRWzVbcllrw_"), paige: driveImage("1KfvZ1RFmQbgiRz2uMpSHP8HAETeLwrl_"), paradox: driveImage("1buZDXehl7I43nkkVqIL53iM48PUoWjLr"), pocket: driveImage("1MUBTymwRgthgHToVTjliCsBblk_dCK5e"), puppy: driveImage("1p8lUxMq0pu1AyE2hFeUrkYtIgcZUA-bs"), rem: driveImage("1E5U8XJOoQZEbRI0-yIrQMx5FgEJgksk4"), seven: driveImage("1CS5prT84-0T1AKudncA3w0HdV9ix7jfF"), shiv: driveImage("1LdzQ8zHiEB4VElseZUma_c3Scx0m93LZ"), silver: driveImage("1lYi13SN0qnv-YmKEhiSMP-F0l2UG9XRU"), sinclair: driveImage("1bWLlas0aM-xYWagQ4z-DYT2HyczPrgQi"), venator: driveImage("1vQTmdtfWDN7UOGXCTyaEztfGE4xiLEvf"), victor: driveImage("1R7eF3YOIDNZpN3xNJN6VeaZv98w4Mwo7"), vindicta: driveImage("17zehwCzCizH-zdpLri7eO5UhRwkDi8xX"), viscous: driveImage("1ATjL6QwV-rQS2mrM5ktLrHkIj7yyJ_u4"), vyper: driveImage("18CCWqkV6QVl61jbW2hlInmyHOJJpUHmp"), warden: driveImage("158xOwahPdh-suv6A2Zb9sJld7w7KFw27"), wraith: driveImage("1mBJTAwnfypGGH4bJEQTjrn9nBlTMzcxs"), yamato: driveImage("1n9PnXP69_fPH2n9rq1xVmKR2V9BbAqqx"),
};

export const catImageForHero = (hero) => CAT_HERO_IMAGES[normalizeHeroName(hero?.name || hero?.hero_name)];
export const heroImageWithCatMode = (hero, fallback, enabled) => enabled ? catImageForHero(hero) || fallback : fallback;

export const readCatMode = () => {
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage?.getItem(CAT_MODE_KEY) === "true";
  } catch {
    return false;
  }
};
export const writeCatMode = (enabled) => {
  if (typeof window === "undefined") return;
  try {
    window.localStorage?.setItem(CAT_MODE_KEY, enabled ? "true" : "false");
  } catch {
    // Some embedded browser contexts disable storage; the live event still applies the mode.
  }
  try {
    window.dispatchEvent(new CustomEvent(CAT_MODE_EVENT, { detail: enabled }));
  } catch {
    const event = document.createEvent("Event");
    event.initEvent(CAT_MODE_EVENT, false, false);
    event.detail = enabled;
    window.dispatchEvent(event);
  }
};

export const useCatMode = () => {
  const [enabled, setEnabled] = useState(readCatMode);
  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const sync = (event) => setEnabled(event.type === CAT_MODE_EVENT ? Boolean(event.detail) : readCatMode());
    window.addEventListener(CAT_MODE_EVENT, sync);
    window.addEventListener("storage", sync);
    return () => { window.removeEventListener(CAT_MODE_EVENT, sync); window.removeEventListener("storage", sync); };
  }, []);
  return enabled;
};

// Sitewide fallback: any hero image with a hero name in its alt text is automatically
// cat-swapped. This covers old/new pages even when they don't explicitly call
// heroImageWithCatMode, while leaving avatars, item art, maps and backgrounds alone.
export const useSitewideCatMode = () => {
  const enabled = useCatMode();
  useEffect(() => {
    if (typeof document === "undefined") return undefined;
    const apply = (root = document) => {
      const isImage = typeof HTMLImageElement !== "undefined" && root instanceof HTMLImageElement;
      const images = isImage ? [root] : root.querySelectorAll?.("img") || [];
      images.forEach((img) => {
        const cat = CAT_HERO_IMAGES[normalizeHeroName(img.alt)];
        if (!cat) return;
        if (enabled) {
          // Components using heroImageWithCatMode already render the cat URL.
          // Recording that URL as the original prevents the image reverting on toggle off.
          if (img.src === cat) return;
          if (!img.dataset.catOriginalSrc) img.dataset.catOriginalSrc = img.src;
          img.src = cat;
        } else if (img.dataset.catOriginalSrc) {
          img.src = img.dataset.catOriginalSrc;
          delete img.dataset.catOriginalSrc;
        }
      });
    };
    apply();
    if (typeof MutationObserver === "undefined" || !document.body) return undefined;
    const observer = new MutationObserver((mutations) => mutations.forEach((mutation) => {
      if (mutation.type === "attributes") apply(mutation.target);
      mutation.addedNodes.forEach((node) => { if (node.nodeType === 1) apply(node); });
    }));
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["src", "alt"] });
    return () => observer.disconnect();
  }, [enabled]);
};
